import React from "react";
import { useNavigate } from "react-router-dom";
import DynamicContentCard from './DynamicContentCard';

const LearningTrackingCard = ({ contentList, paramurl1, paramurl2 }) => {

    const navigate = useNavigate();

    const isMarked = (content) => {
        return content.pendingMessagesCount > 0 || content.pendingSubmissionsCount > 0;
    }

    return (
        <DynamicContentCard
            contentList={contentList}
            isMarkedFunc={(pendingMessagesCount) => isMarked(pendingMessagesCount)}
            onClick={(id) => navigate(`${paramurl1}/${id}/${paramurl2}`)}
            onClickPropertyName="id"
        />
    )
}

export default LearningTrackingCard